import React from 'react';
import RowMenuBar from 'main/components/show/cuesheet/itemCell/rowMenuBar.jsx';
import ItemCellNumber from 'main/components/show/cuesheet/itemCell/number.jsx';
import ItemSelectionState from 'main/components/show/cuesheet/itemCell/selectionState.jsx';
import ItemLock from 'main/components/show/cuesheet/itemCell/lock.jsx';
import Segment from 'main/components/show/cuesheet/itemCell/segment.jsx';
import {
  EditableCellTypes,
  PlaceholderItemSegment,
  PlaceholderTitleRowItemSegment,
} from 'flux/stores/cuesheet/CuesheetConstants';
import classNames from 'classnames';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import ItemTrackButton from 'main/components/show/cuesheet/itemCell/trackButton';
import TrackingUserPill from 'main/components/show/cuesheet/itemCell/trackingUserPill';

/**
 * Item Cell component (compact)
 *
 */
export default React.createClass({
  displayName: 'ItemCell',

  mixins: [HighlightCellMixin],

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    isCopied: React.PropTypes.bool,
    isTitleCopied: React.PropTypes.bool,
    checkSelectionStatus: React.PropTypes.func, //EditableCellType
    editing: React.PropTypes.string, //EditableCellType
    corrupted: React.PropTypes.bool, //EditableCellType
    rowId: React.PropTypes.string, //RowId
    rowType: React.PropTypes.string, //RowType
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    user: React.PropTypes.object.isRequired,
  },

  render() {
    const {
      checkSelectionStatus,
      editing,
      isCopied,
      item,
      isTitleCopied,
    } = this.props;

    let { rowSelected, user, rowIndex } = this.props;

    let wrapperClasses = classNames('cs-item-cell-wrapper');

    let cellClasses = classNames(
      'cs-item-cell',
      'cs-cell',
      { 'cs-cell-copied': isCopied },
      this.getPersonalHighlightClass(),
    );

    let segmentPlaceholder = item.get('titleView')
      ? PlaceholderTitleRowItemSegment
      : PlaceholderItemSegment;

    const { teamId, eventId } = this.context.router.state.params;

    return (
      <div data-testid="item-cell" className={wrapperClasses}>
        <div
          style={Object.assign(
            {},
            this.getGlobalHighlightStyle(),
            this.getPersonalHighlightStyle(),
          )}
          className={cellClasses}
        >
          <ItemLock {...this.props} isLocked={item.get('locked')} />
          <ItemCellNumber
            {...this.props}
            isSelected={checkSelectionStatus(EditableCellTypes.ItemNumber)}
            isEditing={editing === EditableCellTypes.ItemNumber}
          />
          <ItemSelectionState
            user={user}
            rowIndex={rowIndex}
            isSelected={rowSelected}
          />
          <RowMenuBar {...this.props} />
          <div className="cs-item-cell-content">
            <TrackingUserPill {...this.props} />
            <ItemTrackButton
              {...{ teamId, eventId }}
              rowIndex={this.props.rowIndex}
            />
            <Segment
              data-testid="item-cell-segment"
              {...this.props}
              className={'cs-segment-container'}
              isCopied={isTitleCopied}
              isSelected={checkSelectionStatus(EditableCellTypes.ItemTitle)}
              isEditing={editing === EditableCellTypes.ItemTitle}
              placeholder={segmentPlaceholder}
              titleFormat={item.get('titleFormat')}
              titleView={item.get('titleView')}
              title={item.get('title')}
            />
          </div>
        </div>
      </div>
    );
  },
});
